// Angular
import { Component, HostBinding, OnInit, Input } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
// RxJS
import { filter } from 'rxjs/operators';
// Translate
import { TranslationService } from '../../../../../core/_base/layout';
import { AuthService } from '../../../../../core/auth/_services/auth.service';
import { environment } from 'src/environments';

interface LanguageFlag {
	lang: string;
	name: string;
	flag: string;
	active?: boolean;
}

@Component({
	selector: 'kt-language-selector',
	templateUrl: './language-selector.component.html',
	styleUrls: ['./language-selector.component.scss']
})
export class LanguageSelectorComponent implements OnInit {
	// Public properties
	@HostBinding('class') classes = '';
	@Input() iconType: '' | 'brand';

	language: LanguageFlag;
	languages: LanguageFlag[] = [
		{
			lang: 'esAR',
			name: 'Español',
			flag: environment.assets.spanishLangFlat ?? './assets/media/flags/016-spain.svg'
		},
		{
			lang: 'enUS',
			name: 'English',
			flag: environment.assets.englishLangFlat ?? './assets/media/flags/012-uk.svg'
		},
		{
			lang: 'ptBR',
			name: 'Português',
			flag: environment.assets.portugueseLangFlat ?? './assets/media/flags/011-brazil.svg'
		}
		// {
		// 	lang: 'ch',
		// 	name: 'Mandarin',
		// 	flag: './assets/media/flags/015-china.svg'
		// },
		// {
		// 	lang: 'jp',
		// 	name: 'Japanese',
		// 	flag: './assets/media/flags/014-japan.svg'
		// },
		// {
		// 	lang: 'de',
		// 	name: 'German',
		// 	flag: './assets/media/flags/017-germany.svg'
		// },
		// {
		// 	lang: 'fr',
		// 	name: 'French',
		// 	flag: './assets/media/flags/019-france.svg'
		// },
	];

	/**
	 * Component constructor
	 *
	 * @param translationService: TranslationService
	 * @param router: Router
	 */
	constructor(
		private translationService: TranslationService,
		private router: Router,
		private _auth: AuthService
	) {
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit() {
		const userLanguage = this._auth.currentUserLanguage || 'esAR';

		this.setLanguage(userLanguage);
		this.setSelectedLanguage();
		this.router.events
			.pipe(filter(event => event instanceof NavigationStart))
			.subscribe(event => {
				this.setSelectedLanguage();
			});
	}

	/**
	 * Set language
	 *
	 * @param lang: any
	 */
	setLanguage(lang) {
		this.languages.forEach((language: LanguageFlag) => {
			if (language.lang === lang) {
				language.active = true;
				this.language = language;
			} else {
				language.active = false;
			}
		});
		// Check for if the language actually exists, can be erased past release/1.4.0
		lang = this.languages.some(x => x.lang == lang) ? lang : 'esAR'
		// end of check
		this.translationService.setLanguage(lang);
	}

	/**
	 * Set selected language
	 */
	setSelectedLanguage(): any {
		this.setLanguage(this.translationService.getSelectedLanguage());
	}
}
